<!-- 注册 -->
<template>
  <div class="detail-wrap">
      <Breadcrumb :title="title" />
      <el-row :gutter="18">
          <el-col :span="4">
              <el-row class="title"></el-row>
              <!-- <el-image :src="loginUrl" class="login-bg"></el-image> -->
          </el-col>
          <el-col :span="10">
              <el-row class="title">用户注册！</el-row>
              <el-tabs v-model="activeName" type="border-card"  style="width:600px;margin:30px">
                  <el-tab-pane label="用户信息" name="first">
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
                          <el-form-item label="姓名" prop="username"  style="width:500px">
                              <el-input   v-model="ruleForm.username" placeholder="姓名" maxlength="11"></el-input>
                          </el-form-item>
                          <el-form-item label="密码" prop="password"  style="width:500px">
                              <el-input v-model="ruleForm.password" :type="pwType" @input="pwInput" maxlength="16"
                                  autocomplete="new-password" placeholder="设置密码"></el-input>
                          </el-form-item>
                          <el-form-item label="手机号" prop="phone"  style="width:500px">
                              <el-input v-model="ruleForm.phone" @input="handleInput"
                              placeholder="手机号" maxlength="11"></el-input>
                          </el-form-item>
                          <el-form-item label="验证码" prop="varifyCode"  style="width:500px">
                              <el-input v-model="ruleForm.varifyCode" placeholder="验证码">
                                  <template slot="append">
                                      <el-button @click="sendPhoneCode" :disabled="disabledCode">{{ codeMsg }}</el-button>
                                  </template>
                              </el-input>
                          </el-form-item>                            
                          <el-form-item label="地区" prop="area"  style="width:500px">
                                <el-select v-model="ruleForm.provice" style="width:45%" @change="handleChangeArea">
                                    <el-option
                                        v-for="item in areaList"
                                        :key="item.code"
                                        :label="item.label"
                                        :value="item.label"
                                        >
                                    </el-option>
                                </el-select>
                                <el-select v-model="ruleForm.city" style="width:45%" @change="handleChangecity">
                                    <el-option
                                        v-for="item in cityList"
                                        :key="item.code"
                                        :label="item.label"
                                        :value="item.label"
                                        >
                                    </el-option>
                                </el-select>
                          </el-form-item>
                          <el-form-item>
                              <el-button type="primary" round :loading="false" style="width: 220px;"
                                  @click="submit('ruleForm')">注册</el-button>
                          </el-form-item>
                      </el-form>
                  </el-tab-pane>
                  <!-- <el-tab-pane label="短信登录" name="second">
                      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
                          <el-form-item label="手机号" prop="phone" required style="width:500px">
                              <el-input v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
                          </el-form-item>
                          <el-form-item label="验证码" prop="varifyCode" required style="width:500px">
                              <el-input v-model="ruleForm.varifyCode" placeholder="请输入验证码">
                                  <template slot="append">
                                      <el-button @click="sendPhoneCode" :disabled="disabledCode">{{ codeMsg }}</el-button>
                                  </template>
                              </el-input>
                          </el-form-item>
                          <el-form-item>
                              <el-button type="primary" round style="width: 220px;" :loading="false"
                                  @click="loginSMS('ruleForm')">提交</el-button>
                          </el-form-item>
                      </el-form>
                  </el-tab-pane> -->
              </el-tabs>
          </el-col>
      </el-row>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import areaList from '@/assets/js/city'
export default {
  components: {
      Breadcrumb
  },
  data() {
      return {
          ruleForm: {},
          activeName: 'first',
          ruleForm: {
              username: '',
              password: '',
              phone: '',
              varifyCode: '',
              area: '',
              provice: '',
              city: '',
          },
          areaList: areaList.provinces,
          cityList: [],
          rules: {
                username: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 1, max: 16, message: '长度在 1 到 16 个字符', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { min: 3, max: 11, message: '长度在 11 位字符', trigger: 'blur' }
                ],
                varifyCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { min: 3, max: 6, message: '长度在 3 到 6 个字符', trigger: 'blur' }
                ],
          },
          codeMsg: '发送验证码',
          seconds: 120,
          timer: null,
          disabledCode: false,
          pwType: 'text',
          pwKey: 0,
      }
  },
  created() {
  },
  mounted() {

  },
  computed: {
      title() {
          return this.$route.meta.title
      },
  },
  methods: {
      submit(formName) {
            let { username, password,phone, varifyCode,provice, city} = this.ruleForm;
            this.$refs[formName].validate((valid) => {
              if (valid) {
                  let params = {
                      opcode: this.$code.RegisterCode,
                      v_name: username,
                      v_company: '',
                      v_order_pass: password,
                      v_phone: phone,
                      v_verify_code: varifyCode,
                      //非必填字段 
                      v_caption: '',
                      v_nickName: '',
                      openId: '',
                      unionId: '',
                      i_voucher_up_image: '',
                      i_voucher_down_image: '',
                      i_avatar_image: '',
                      v_synopsis: '',   
                      v_details: '',
                      v_summary: '', 
                      v_provice:  provice,
                      city: city                   
                  }
                  this.$api._requestAPI(params).then(res => {
                      if (res.IsSuccess) {
                          setTimeout(() => {                                
                              this.$message.success(res.Message)
                              this.$router.push('/login');
                          }, 500);
                      } else {
                          this.$message.error(res.Message)
                      }
                  }).catch(err => {
                      this.$message.error(err)
                  })
              } else {
                  console.log('error submit!!');
                  return false;
              }
          })
        },
        sendPhoneCode() {
          if (this.ruleForm.phone == '') {
              this.$message.error('请输入手机号');
              return false;
          }
          if (!this.$help.isMobile(this.ruleForm.phone)) {
              this.$message.error('请输入正确的手机号');
              return false;
          }
          let params = {
              opcode: this.$code.SMS,
              v_phone: this.ruleForm.phone,
          }

          this.$api._requestAPI(params).then(res => {
              if (res.IsSuccess) {
                  this.$message.success('发送成功')
              } else {
                  this.$message.error(res.Message)
              }
          }).catch(err => {
              console.log(err);
          })

          this.timer = setInterval(() => {
              if (this.seconds == 0) {
                  clearInterval(this.timer);
                  this.disabledCode = false;
                  this.codeMsg = '重新发送';
                  this.seconds = 120;
              } else {
                  this.seconds--
                  this.disabledCode = true;
                  this.codeMsg = this.seconds + '秒后重发'
              }
          }, 1000)
        },
        pwInput(e) {
            if (e) {
                this.pwType = 'password'
            } else {
                this.pwKey++
                this.pwType = 'text'
            }
        },
        handleChangeArea(value){
            this.cityList = []
            this.ruleForm.provinces = value
            this.ruleForm.city = ''
            let cityObj = this.areaList.filter(i=> i.label === value)
            this.cityList = cityObj[0].cities
        },
        handleChangecity(value){
            this.ruleForm.city = value
        },
        // 只能输入数字，限制输入其它字符
        handleInput(value){
            const pattern = /^[0-9]\d*$/g
            if (pattern.test(value)) {
                // 双向绑定
                this.ruleForm.phone = value
            } else {
                // 输入值不为正整数，则从中提取出数字并拼接为字符串，赋值给username
                const num = value.match(/\d+/g)
                this.ruleForm.phone = num ? num.join('') : ''
            }
        },
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';

.detail-wrap {
  width: 1000px;
  margin-top:80px;
  min-height: 500px;
}

.title {
  padding: 30px;
  font-size: 22px;
}
</style>


// WEBPACK FOOTER //
// src/views/login/register.vue